import { render, staticRenderFns } from "./InvestmentLineChart.vue?vue&type=template&id=6bb6c18d&scoped=true"
import script from "./InvestmentLineChart.vue?vue&type=script&lang=ts"
export * from "./InvestmentLineChart.vue?vue&type=script&lang=ts"
import style0 from "./InvestmentLineChart.vue?vue&type=style&index=0&id=6bb6c18d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb6c18d",
  null
  
)

export default component.exports